import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Content_Paths } from "./sysGuardConstants";
import { useSelector } from "react-redux";

function SysGuardAlertViewSwitch({ onToggle }) {
  const location = useLocation();
  const history = useHistory();

  // Determine active tab based on current path
  const isOverviewPath = Content_Paths.includes(location.pathname);
  const [activeTab, setActiveTab] = useState(isOverviewPath ? "overview" : "alert");
  const alertCount = useSelector((state) => state.alertCount.alertCount);

  useEffect(() => {
    setActiveTab(isOverviewPath ? "overview" : "alert");
  }, [location.pathname]);

  const handleToggle = (tab) => {
    if (tab === activeTab) return; // Avoid re-push on same tab
    setActiveTab(tab);
    if (onToggle) onToggle(tab);

    if (tab === "overview" && !isOverviewPath) {
      history.push("/mdr/sysguard/content/Users");
    } else if (tab === "alert" && location.pathname !== "/mdr/alerts") {
      history.push("/mdr/alerts");
    }
  };

  return (
    <div className="sys-toggle-container">
      <div
        className={`toggle-option ${activeTab === "overview" ? "active" : ""}`}
        title={`${activeTab === "overview" ? "" : "Switch to Overview"}`}
        onClick={() => handleToggle("overview")}
      >
        Overview
      </div>
      <div
        className={`toggle-option ${activeTab === "alert" ? "active" : ""}`}
        title={`${activeTab === "alert" ? "" : "Switch to Alerts"}`}
        onClick={() => handleToggle("alert")}
      >
        Alerts
        {/* {alertCount > 0 && <span className="alert-dot" />} will use this in future */}
      </div>
    </div>
  );
}

export default SysGuardAlertViewSwitch;
